import * as React from 'react';
import * as ReactDOM from 'react-dom';

import {Provider} from 'react-redux';
import {SignUp} from '../components/signup-page/signup-page';
import store from '../redux/sign-up/store';
import '../styles/common.sass';

ReactDOM.render(
  <Provider store={store}>
    <SignUp />
  </Provider>,
  document.getElementById('sign-up-container'),
);
